import { render, staticRenderFns } from "./PlatformVersion.vue?vue&type=template&id=0e9255d4&"
import script from "./PlatformVersion.vue?vue&type=script&lang=js&"
export * from "./PlatformVersion.vue?vue&type=script&lang=js&"
import style0 from "./PlatformVersion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports